import React from "react";

// Скелеты загрузки — как на nexfill.ws: вместо надписи «Загрузка…» в
// прямоугольнике рисуется приглушённая заготовка будущей раскладки, которая
// мягко пульсирует (pulse 2s), а по готовности содержимое проявляется на её
// месте. Цвета — от поверхности панели, поэтому подходят всем темам.

// Один блок заготовки. Размеры задаются через style.
export const SkeletonBlock = ({ style, className = "", radius = 10 }) => (
  <div
    aria-hidden="true"
    className={`kl-skeleton ${className}`.trim()}
    style={{ borderRadius: `${radius}px`, ...(style || {}) }}
  />
);

// Заготовка раздела целиком: шапка (иконка, название, подзаголовок), ряд из
// трёх плашек и большое поле содержимого с несколькими строками. Показывается,
// пока грузится код раздела.
export const SectionSkeleton = ({ isPhoneView = false, rows = 4 }) => (
  <div className="kl-section-skeleton" aria-busy="true" aria-live="polite">
    <div style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "22px" }}>
      <SkeletonBlock style={{ width: "44px", height: "44px", flexShrink: 0 }} radius={14} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <SkeletonBlock style={{ width: isPhoneView ? "56%" : "220px", height: "20px", marginBottom: "10px" }} radius={7} />
        <SkeletonBlock style={{ width: isPhoneView ? "78%" : "320px", height: "12px" }} radius={6} />
      </div>
    </div>
    <div style={{
      display: "grid",
      gridTemplateColumns: isPhoneView ? "repeat(2, minmax(0, 1fr))" : "repeat(3, minmax(0, 1fr))",
      gap: "12px",
      marginBottom: "16px"
    }}>
      {[0, 1, 2].slice(0, isPhoneView ? 2 : 3).map((i) => (
        <SkeletonBlock key={i} style={{ height: isPhoneView ? "54px" : "62px" }} radius={16} />
      ))}
    </div>
    <div className="kl-skeleton-panel">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", gap: "14px", padding: "14px 0" }}>
          <SkeletonBlock style={{ width: "40px", height: "40px", flexShrink: 0 }} radius={12} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <SkeletonBlock style={{ width: `${62 - (i % 3) * 9}%`, height: "13px", marginBottom: "9px" }} radius={6} />
            <SkeletonBlock style={{ width: `${38 + (i % 2) * 10}%`, height: "11px" }} radius={6} />
          </div>
          <SkeletonBlock style={{ width: isPhoneView ? "48px" : "84px", height: "30px", flexShrink: 0 }} radius={10} />
        </div>
      ))}
    </div>
  </div>
);

// Заготовка списка карточек: пока грузятся данные раздела.
export const ListSkeleton = ({ rows = 4, isPhoneView = false, cardHeight }) => (
  <div className="kl-list-skeleton" aria-busy="true" aria-live="polite" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="kl-skeleton-card" style={cardHeight ? { minHeight: cardHeight } : undefined}>
        <SkeletonBlock style={{ width: isPhoneView ? "56px" : "72px", height: isPhoneView ? "56px" : "72px", flexShrink: 0 }} radius={14} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <SkeletonBlock style={{ width: `${58 - (i % 3) * 8}%`, height: "14px", marginBottom: "10px" }} radius={6} />
          <SkeletonBlock style={{ width: `${80 - (i % 2) * 14}%`, height: "12px", marginBottom: "8px" }} radius={6} />
          <SkeletonBlock style={{ width: "34%", height: "11px" }} radius={6} />
        </div>
        {!isPhoneView && <SkeletonBlock style={{ width: "92px", height: "34px", flexShrink: 0 }} radius={11} />}
      </div>
    ))}
  </div>
);

// Заготовка сетки карточек (парсер): плитки с картинкой и двумя строками.
export const GridSkeleton = ({ count = 8, isPhoneView = false }) => (
  <div aria-busy="true" aria-live="polite" style={{
    display: "grid",
    gridTemplateColumns: isPhoneView ? "repeat(2, minmax(0, 1fr))" : "repeat(auto-fill, minmax(190px, 1fr))",
    gap: "12px"
  }}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="kl-skeleton-card" style={{ flexDirection: "column", alignItems: "stretch", gap: "10px", padding: "10px" }}>
        <SkeletonBlock style={{ width: "100%", aspectRatio: "4 / 3" }} radius={12} />
        <SkeletonBlock style={{ width: `${70 - (i % 3) * 10}%`, height: "13px" }} radius={6} />
        <SkeletonBlock style={{ width: "40%", height: "12px" }} radius={6} />
      </div>
    ))}
  </div>
);

export default SkeletonBlock;
